import {useEffect, useReducer} from "react";
import {parseRouteResponse} from "../../../services/route-response";

let cache = {};

const reducer = (state, action) => {
    switch (action.type) {
        case 'setData':
            return action.payload;
        case 'addToFavorite':
            const addedToProgramState = {
                ...state,
                userData: {
                    ...state.userData,
                    isInFavorite: true
                },
            };
            cache[action.conferenceId] = addedToProgramState;

            return addedToProgramState;
        case 'removeFromFavorite':
            const removedFromProgramState = {
                ...state,
                userData: {
                    ...state.userData,
                    isInFavorite: false
                },
            }
            cache[action.conferenceId] = removedFromProgramState;

            return removedFromProgramState;
        case 'checkIn':
            const checkInState = {
                ...state,
                userData: {
                    ...state.userData,
                    isUserCheckedIn: true
                },
            }
            cache[action.conferenceId] = checkInState;

            return checkInState;
        default:
            throw new Error();
    }
}

export default function useEventData(id) {
    const [eventData, dispatch] = useReducer(reducer, cache[id]);

    useEffect(() => {
        if (!cache[id]) {
            fetch('/api/v1/conference/' + id)
                .then(async (response) => {
                    const result = await response.json().catch(() => null);
                    const {kind} = parseRouteResponse(response, result);

                    if (kind === 'not_found') {
                        const notFoundPayload = {state: 'not_found'};
                        cache[id] = notFoundPayload;

                        dispatch({
                            type: 'setData',
                            payload: notFoundPayload,
                        });
                        return;
                    }

                    if (kind !== 'ok' || !result) {
                        return;
                    }

                    cache[id] = result;
                    dispatch({
                        type: 'setData',
                        payload: result,
                    });
                })
        }
    }, [id]);

    return [eventData, dispatch];
}
